import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Cookies from "js-cookie";

const ToggleDarkMode = ({ compact = false }) => {

  // Initialize state to determine if dark mode is enabled or not.
  const [isDarkMode, setIsDarkMode] = useState(() => {
    return Cookies.get("darkMode") === "true";
  });

  // Effect to apply dark mode styles to the document body and set a cookie.
  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("dark-mode");
      Cookies.set("darkMode", "true", { expires: 365 });
    } else {
      document.body.classList.remove("dark-mode");
      Cookies.set("darkMode", "false", { expires: 365 });
    }
  }, [isDarkMode]);

  return (
    // Form to toggle dark mode on and off.
    <Form className={`d-flex align-items-center dark-mode-toggle-form ${compact ? "compact" : ""}`}>
      {!compact && (
        <label htmlFor="dark-mode-toggle" className="me-2 dark-mode-label">
          Dark Mode:
        </label>
      )}
      {compact && (
        <span className="me-2 dark-mode-label compact">Dark mode</span>
      )}
      <Form.Check
        type="switch"
        id="dark-mode-toggle"
        checked={isDarkMode}
        onChange={() => setIsDarkMode(!isDarkMode)}
      />
    </Form>
  );
};

export default ToggleDarkMode;
